export { DeviceTable } from './DeviceTable'
